import { Button, Form, Input } from 'antd';
import { useContext} from 'react';
import { UserContext } from '../Context/UserContext';
import axios from 'axios'
import { useHistory } from 'react-router-dom';


const ChangePassword = () => {
    const [user] = useContext(UserContext)
    const [,,,setDashboard] = useContext(UserContext)
    const history = useHistory()
    const HandleCancel = () => {
        history.push("/profile")
    }
    console.log(user.id)
    const onFinish = (values) => {
        if (user){
            axios.post("https://super-bootcamp-backend.sanbersy.com/api/change-password", {...values}, {headers: {"Authorization" : "Bearer "+ user.token}})
                .then((res) => {
                    setDashboard(true)
                    history.push("/profile")
                    alert("Password Berhasil Diganti")
                }).catch((err) => {
                    console.log(err)
                    alert("Password Gagal Diganti")
                })
        }
      };

      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

    return (
        <Form
            name="changePassword"
            labelCol={{
                span: 8,
            }}
            wrapperCol={{
                span: 8,
            }}
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            >
            {/* <h1>Change Password</h1> */}
            <Form.Item
                label="Current Password"
                name="current_password"
                rules={[
                {
                    required: true,
                    message: 'Please input your current password!',
                },
                ]}
            >
                <Input.Password />  
            </Form.Item>

            <Form.Item
                label="New Password"
                name="new_password"
                rules={[
                    {
                        required: true,
                        min: 6,
                        message: 'Please input your password more than 6 character!',
                    }
                ]}
            >
                <Input.Password />  
            </Form.Item>

            <Form.Item
                label="Confirm Password"
                name="new_confirm_password"
                rules={[
                    {
                        required: true,
                        min: 6,
                        message: 'Please input your password more than 6 character!',
                    }
                ]}
            >
                <Input.Password />  
            </Form.Item>

            <Form.Item
                wrapperCol={{
                offset: 8,
                span: 16,
                }}
            >
                <Button type="primary" htmlType="submit">
                Submit
                </Button>
                <Button type="danger" onClick={HandleCancel} style={{marginLeft: "20px"}}>
                Cancel
                </Button>
            </Form.Item>
        </Form>
    )
}

export default ChangePassword